module.exports = __webpack_public_path__ + "static/media/Nickainley-01.9a4b50de.svg";